
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-[#0F4C81] to-[#1E88E5] text-white py-16">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-black mb-4">LineFlow Underground & Civil</h3>
            <p className="text-white/80 mb-4 leading-relaxed">
              Professional plumbing and civil engineering services for new home construction and underground infrastructure projects.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#FF6B35] rounded-lg transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#FF6B35] rounded-lg transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#FF6B35] rounded-lg transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#FF6B35] rounded-lg transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2 text-white/80">
              <li>
                <a href="#services" className="hover:text-[#FF6B35] transition-colors cursor-pointer">New Home Plumbing</a>
              </li>
              <li>
                <a href="#services" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Underground Piping</a>
              </li>
              <li>
                <a href="#services" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Civil Engineering Support</a>
              </li>
              <li>
                <a href="#services" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Commercial Projects</a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-white/80">
              <li>
                <a href="/" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Home</a>
              </li>
              <li>
                <a href="/projects" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Projects</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Contact</a>
              </li>
              <li>
                <a href="/admin" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Admin</a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-2">
                <i className="ri-phone-fill text-[#FF6B35] mt-1"></i>
                <div className="flex flex-col gap-1">
                  <a href="tel:0410880821" className="hover:text-[#FF6B35] transition-colors cursor-pointer">
                    0410 880 821
                  </a>
                  <a href="tel:0412212971" className="hover:text-[#FF6B35] transition-colors cursor-pointer">
                    0412 212 971
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-fill text-[#FF6B35] mt-1"></i>
                <a href="mailto:info@lineflow.com.au" className="hover:text-[#FF6B35] transition-colors cursor-pointer">
                  info@lineflow.com.au
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-fill text-[#FF6B35] mt-1"></i>
                <span>Metro Area & Surrounding Regions</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/70 text-sm">
            © {currentYear} LineFlow Underground & Civil. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-white/70">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF6B35] transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
